import styled from 'styled-components';
import { Dropdown, theme } from 'components';

export const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-column-gap: 17px;
  grid-row-gap: 13px;
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledPhotoLabel = styled.div`
  grid-column: 2 / span 4;
  display: flex;
  align-items: center;
`;

export const StyledPhotosContainer = styled.div`
  grid-column: 2 / span 4;
  overflow-x: auto;
`;

export const StyledPhotoGrid = styled.div`
  display: grid;
  grid-auto-columns: 90px;
  grid-auto-flow: column;
  grid-gap: 10px;
`;

export const StyledThumbnail = styled.div`
  border-radius: ${theme.getBorderRadius('medium')};
  overflow: hidden;
  width: 100%;
  height: 150px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StyledPhoto = styled.div<{ $imageUrl: string }>`
  border-radius: ${theme.getBorderRadius('small')};
  background-image: url('${({ $imageUrl }) => $imageUrl}');
  background-size: cover;
  background-position: center;
  cursor: grab;
  position: relative;
  &:before {
    content: '';
    padding-bottom: 100%;
    display: inline-block;
    vertical-align: top;
  }
`;

export const StyledUtilityContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 6px;
  display: flex;
`;

export const StyledUtilityButton = styled.div<{ $isDrag?: boolean }>`
  cursor: ${({ $isDrag }) => ($isDrag ? 'grab' : 'pointer')};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  margin-left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPreviewImage = styled.img`
  width: 100%;
  max-height: calc(100vh - 400px);
  object-fit: contain;
`;

export const StyledDropdown = styled(Dropdown)`
  > div {
    transform: translate(11px, 0) rotate(45deg);
  }
  > ul {
    transform: translate(11px, 0);
  }
`;
